export default function HistoryIcon({ color }:{ color: string}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 12C20 16.4183 16.4183 20 12 20C8.33569 20 5.24679 17.5364 4.29927 14.1752L3.32849 14.4179C4.38476 18.2142 7.86705 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.51707 3 5.49623 4.97844 4 7.8728V5H3V10.0409H8V9.04094H4.56508C5.74158 6.08744 8.62702 4 12 4C16.4183 4 20 7.58172 20 12Z"
          fill={color}
        />
        <path
          d="M12.5 7V11.7929L15.8536 15.1464L15.1464 15.8536L11.5 12.2071V7H12.5Z"
          fill={color}
        />
      </svg>
    </>
  );
}
